export const colorMoods = [
  { label: "Auto", value: "auto" },
  { label: "Calm", value: "calm" },
  { label: "Energized", value: "energetic" },
  { label: "Warm", value: "warm" },
  { label: "Playful", value: "playful" },
  { label: "Dramatic", value: "dramatic" },
  { label: "Sophisticated", value: "sophisticated" },
];
export const colorSchemes = [
  { label: "Auto", value: "auto" },
  { label: "Monochrome", value: "monochrome" },
  // { label: "Monochrome Light", value: "monochrome-light" },
  // { label: "Monochrome Dark", value: "monochrome-dark" },
  // { label: "Triadic", value: "triad" },
  // { label: "Quadratic", value: "quad" },
  { label: "Analogous", value: "analogic" },
  { label: "Complementary", value: "complement" },
  // { label: "Analogous Complementary", value: "analogic-complement" },
];

export const PALETTE_TYPES = {
  WHEEL: "wheel",
  SEGMENT: "segment",
};

// ---------------------------------------------------------------------------
// Palette stabilization flags (Claude, palette-stabilization 2026-06-13)
// ---------------------------------------------------------------------------
// These gate the bug-fix behaviour for the chronically-glitchy palette system.
// Default ON (the stable behaviour); flip to false to restore the legacy
// always-regenerate behaviour without a redeploy-by-revert. Reading from an
// env var lets ops/QA kill-switch at build time (REACT_APP_*); the `!== "false"`
// shape means "on unless explicitly disabled".
//
//  - PALETTE_REGEN_ONLY_ON_COLOR_CHANGE: a segment palette is (re)generated ONLY
//    when the segment's base color actually changed. If a segment already has a
//    palette whose stored base color === the current color, we reuse it instead
//    of firing a fresh AI generate-scheme + save-palette. This single guard
//    de-storms the wheel-palette change (LW-01), stops the new-random-IDs
//    re-randomization on every (re)select, and removes the redundant paid AI
//    calls. Idempotent.
export const PALETTE_REGEN_ONLY_ON_COLOR_CHANGE =
  process.env.REACT_APP_PALETTE_REGEN_ONLY_ON_COLOR_CHANGE !== "false";

//  - PALETTE_DEFER_AUTOSAVE_WHILE_GENERATING: the 30s autosave timer skips a
//    tick while any segment-palette generate/save is still in flight, so a save
//    can't persist a stale snapshot whose palette_id/palette_data hasn't landed
//    in Redux yet (LW-02 stale-state save race). The index marker is NOT
//    advanced on a skipped tick, so the change is still saved on the next tick
//    (or on a manual save). Reversible: false restores the always-save-on-tick
//    behaviour.
export const PALETTE_DEFER_AUTOSAVE_WHILE_GENERATING =
  process.env.REACT_APP_PALETTE_DEFER_AUTOSAVE_WHILE_GENERATING !== "false";

// ---------------------------------------------------------------------------
// Segment-palette manual "Regenerate" control (Claude, segment-palette-regenerate 2026-06-13)
// ---------------------------------------------------------------------------
//  - SEGMENT_PALETTE_REGEN_ENABLED: gates the manual "Regenerate" button on the
//    segment palette. This is the DELIBERATE reroll that PR #1711 logged as
//    PAL-002 / open product question #2 ("should an explicit Regenerate be
//    allowed to reroll the same color?"). It is the *only* sanctioned path that
//    bypasses the PALETTE_REGEN_ONLY_ON_COLOR_CHANGE idempotency guard, and it
//    does so exactly ONCE per explicit click (never auto-firing, never
//    N-parallel — the in-flight dedup + a disabled-while-pending button stop
//    double-fire). The AUTO palette stays the stabilized deterministic one from
//    #1711; this control is purely additive on top of it.
//
//    DEFAULT OFF. Opt in at build time with
//    REACT_APP_SEGMENT_PALETTE_REGEN=true. The `=== "true"` shape means
//    "off unless explicitly enabled", so shipping this PR changes NOTHING that
//    users see until ops deliberately turns it on.
export const SEGMENT_PALETTE_REGEN_ENABLED =
  process.env.REACT_APP_SEGMENT_PALETTE_REGEN === "true";
